goog.provide('el8.appshared.react.renderNewMessageThread');


/**
 * Shared function for rendering the new react message thread list.
 * @typedef RenderNewMessageThreadParams
 * @type {object}
 * @property {object} style - A css style object
 * @property {object} listStyle - A css style object to apply to each message thread list
 * @property {number} itemId - The name of the feed i.e. chart, reqAct, etc...
 * @property {string} feedName - The name of the feed i.e. chart, reqAct, etc...
 * @property {object[]} messages - An array of messages to render
 * @property {boolean} showActionButtons - Whether or not to show the action buttons.
 * @property {boolean} showMessageIcon - Whether ot not to show the message icon to the left of the message list.
 * @property {Function} onReplySuccess - The success callback function
 * onActionButtonClick
 * 
 * @param {JQuery} renderedItem The rendered item container
 * @param {RenderNewMessageThreadParams} params 
 */
el8.appshared.react.renderNewMessageThread = function(renderedItem, params) {
    var messageThreadContainerId =  params.feedName + '_' + params.itemId + '-messages';
    var $messageThreadContainer = $("#" + messageThreadContainerId, renderedItem);
    
    if ($messageThreadContainer.length) {
        el8React.render.messageThread(messageThreadContainerId, {
            messages: params.messages,
            style: params.style,
            listStyle: params.listStyle,
            onReplySuccess: params.onReplySuccess,
            showActionButtons: params.showActionButtons || false,
            showMessageIcon: params.showMessageIcon || false
        });
    }
}